<template>
  <b-popover :target="target" triggers="click blur" placement="bottomleft" title="" ref="popover">
    <div class="addToPlaylistPopover">
      <b-form-group label="Add video to">
        <b-form-select v-model="playlist" :options="playlists" size="sm" v-if="playlists" />
      </b-form-group>

      <b-form-group label="New playlist name"  v-if="playlist == -1" >
        <b-form-input size="sm" class="name" v-model="name" />
      </b-form-group>

      <b-button class="btn-rainbow" @click="add" :disabled="!addEnabled">
        add
      </b-button>
      <font-awesome-icon icon="spinner" size="lg" spin v-if="working" />
      <LinkButton :u="true" class="ml-2" @click="close">cancel</LinkButton>
    </div>
  </b-popover>
</template>

<style scoped lang="scss">

  .addToPlaylistPopover {
    width: 15em;

    img {
      width: 1.2em;
      margin-right: 0.5em;
    }

    .amount {
      width: 5em;
      font-size: 0.8em;
    }
  }

</style>

<script>
import { mapGetters } from 'vuex'
import map from 'lodash/map'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import LinkButton from '@/components/widgets/LinkButton'

export default {
  name: 'AddToPlaylist',
  components: {
    FontAwesomeIcon,
    LinkButton
  },
  props: {
    target: String,
    video: Object
  },
  data () {
    return {
      working: false,
      playlists: null,
      playlist: null,
      name: null
    }
  },
  computed: {
    addEnabled () {
      return (this.playlist > 0) || (this.playlist === -1 && !!this.name)
    },
    myVideos () {
      if (!this.isLoggedIn) return null
      return this.currentUser.default_playlists.my_videos
    },
    inMyVideos () {
      if (!this.myVideos) return false
      return this.myVideos.video_ids.indexOf(this.video.id) !== -1
    },
    ...mapGetters('profile', ['currentUser']),
    ...mapGetters('auth', ['isLoggedIn'])
  },
  watch: {
    'currentUser': 'initComponent'
  },
  created () {
    this.initComponent()
  },
  methods: {
    async initComponent () {
      const results = await this.$store.dispatch('playlist/listPlaylists', {profile_id: this.currentUser.id})
      let playlists = map(await results.all(), p => {
        return {
          value: p.id,
          text: p.name
        }
      })

      if (!this.inMyVideos) {
        playlists.unshift({
          value: this.myVideos.id,
          text: 'Save Video'
        })
      }

      playlists.push({
        value: -1,
        text: 'Create new playlist...'
      })

      this.playlists = playlists

      if (!this.inMyVideos) this.playlist = this.myVideos.id
      this.name = ''
    },
    async add () {
      if (!this.addEnabled) return

      this.working = true

      if (this.playlist === -1) {
        let newPlaylist = await this.$store.dispatch('playlist/createPlaylist', {
          name: this.name,
          is_public: false
        })
        this.playlist = newPlaylist.id
        this.playlists.splice(this.playlists.length - 1, 0, {
          value: newPlaylist.id,
          text: newPlaylist.name
        })
      }

      try {
        await this.$store.dispatch('playlist/appendPlaylistSong', {
          playlistId: this.playlist,
          songId: this.video.id
        })
        this.working = false
      } catch (e) {
        this.working = false

        this.$store.dispatch('flash/showMessage', {message: e.message, type: 'error'})
        this.playlist = null
        this.close()
        return
      }

      if (this.playlist === this.myVideos.id) {
        this.myVideos.video_ids.push(this.video.id)
        this.$store.dispatch('flash/showMessage', {message: 'Video added to your Saved Videos'})
      } else {
        this.$store.dispatch('flash/showMessage', {message: 'Video added to playlist'})
      }

      this.playlist = null
      this.close()
    },
    close () {
      this.$refs.popover.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/AddToPlaylist.vue